module.exports = __webpack_public_path__ + "static/media/Rayna T.40f051d2.jpeg";